// Sponsor / partner content for the two sponsor walls. Edited as data
// (assets/sponsors.json) — drop logo PNGs in assets/sponsors/ and add an entry.
// Two groups, one per wall (e.g. "Aliados" and "Patrocinadores").

export interface SponsorLogo {
  name: string;
  image: string; // e.g. "/assets/sponsors/datasketch.png"
  url?: string; // optional link to the organisation
}

export interface SponsorGroup {
  title: string;
  logos: SponsorLogo[];
}

export interface Sponsors {
  groups: SponsorGroup[];
}

const EMPTY: Sponsors = {
  groups: [
    { title: "Aliados", logos: [] },
    { title: "Patrocinadores", logos: [] },
  ],
};

export async function loadSponsors(): Promise<Sponsors> {
  try {
    const res = await fetch("/assets/sponsors.json");
    if (!res.ok) return EMPTY;
    return (await res.json()) as Sponsors;
  } catch {
    return EMPTY; // walls still render their placeholder
  }
}
